import { boot } from 'quasar/wrappers'
import * as Sentry from '@sentry/vue'

export default boot(async ({ store, Vue }) => {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    trackComponents: true,
    beforeSend(event) {
      event.tags = event.tags || {}
      event.tags.piva = store.state.tenant.piva

      const { user } = store.state.auth
      if (user) {
        event.tags.company = user.company.RagioneSociale
        event.user = {
          id: user.value,
          username: user.label,
        }
      }

      // TODO:
      // if (event.exception) {
      //   Sentry.showReportDialog({
      //     eventId: event.event_id,
      //     lang: 'it',
      //     title: 'Sembra che stiamo riscontrando problemi.',
      //     subtitle: 'Il nostro team è stato avvisato.',
      //     subtitle2: 'Se desideri aiutare, raccontaci cosa è successo di seguito.',
      //     labelComments: 'Cosa è Successo?',
      //     labelSubmit: 'Invia il rapporto',
      //     errorFormEntry: 'Alcuni campi non erano validi. Correggi gli errori e riprova.',
      //     successMessage: 'Il tuo feedback è stato inviato. Grazie!'
      //   })
      // }
      return event
    },
  })
})
